// extracted by mini-css-extract-plugin
export var actions = "_50-0";
export var actionsContainer = "_50-7";
export var border = "_50-1";
export var childFullHeight = "_50-f";
export var collapse = "_50-2";
export var content = "_50-a";
export var contentChild = "_50-e";
export var fullscreen = "_50-c";
export var hasLeftRadius = "_50-k";
export var headerContainer = "_50-3";
export var headerRow = "_50-5";
export var hidePadding = "_50-b";
export var navCollapsedGap = "_50-l";
export var noScrollX = "_50-m";
export var noScrollY = "_50-n";
export var noTopPadding = "_50-i";
export var optOutTopPadding = "_50-d";
export var pageMain = "_50-j";
export var pageOuter = "_50-g";
export var pagePadding = "_50-8";
export var pageScroll = "_50-9";
export var profile = "_50-o";
export var profileContainer = "_50-p";
export var profileImage = "_50-q";
export var profileMain = "_50-r";
export var profileSubtitle = "_50-t";
export var profileTitle = "_50-s";
export var showLeftPadding = "_50-h";
export var tabsPortalSlot = "_50-6";
export var tabsWrapper = "_50-4";
export var title = "_50-u";